import _pt from "prop-types";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import * as React from 'react';
import { get as _get } from 'lodash';
import { FieldPreviewLabel } from './FieldPreviewLabel';
import { PkpassFieldsType } from '../../../../../../types';
import { usePkpass } from '../../../usePkpass';
import { FieldPreviewValue } from './FieldPreviewValue';
import { FieldPreviewPrimary } from './FieldPreviewPrimary';
import { createUseStyles } from 'react-jss';
import { getTextAlign } from './getTextAlign';
import { useTheme } from '../../../../Theme';
export const useStyles = createUseStyles({
  field: {
    padding: ({
      theme
    }) => `${theme.scale * 10}px ${theme.scale * 12}px`,
    '&:hover': {
      cursor: ({
        clickable
      }) => clickable ? 'pointer' : undefined,
      opacity: ({
        clickable
      }) => clickable ? 0.7 : undefined
    }
  }
});

const Field = props => {
  const {
    fieldsType,
    fieldIndex
  } = props;
  const {
    pass,
    passStyle,
    onFieldClick,
    onFieldDnD
  } = usePkpass();
  const [dragOver, setDragOver] = React.useState(false);
  const theme = useTheme();
  const classes = useStyles({
    pass,
    theme,
    clickable: !!onFieldClick
  });
  const fieldsPath = `${passStyle}.${fieldsType}`;
  const fieldPath = `${fieldsPath}.${fieldIndex}`;

  const field = _get(pass, `${fieldPath}`);

  const onDragLeave = event => {
    event.stopPropagation();
    event.preventDefault();
    setDragOver(false);
  };

  const onDragOver = event => {
    event.stopPropagation();
    event.preventDefault();
    setDragOver(true);
  };

  const onDragStart = event => {
    event.dataTransfer.setData('droppedFieldsType', fieldsType);
    event.dataTransfer.setData('droppedIndex', `${fieldIndex}`);
  };

  const onDrop = event => {
    event.preventDefault();
    event.stopPropagation();
    const droppedIndex = Number(event.dataTransfer.getData('droppedIndex'));
    const droppedFieldsType = event.dataTransfer.getData('droppedFieldsType');
    onFieldDnD(fieldsType, fieldIndex, droppedFieldsType, droppedIndex);
    setDragOver(false);
  };

  const style = {
    fontSize: 15 * theme.scale,
    minHeight: 26 * theme.scale,
    minWidth: 20 * theme.scale,
    textAlign: props.align || getTextAlign(field.textAlignment),
    zIndex: 100
  };
  let content = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FieldPreviewLabel, {
    key: "fieldPreviewLabel",
    field: field,
    fieldsType: fieldsType,
    labelColor: pass.labelColor,
    theme: theme
  }), /*#__PURE__*/React.createElement(FieldPreviewValue, {
    key: "fieldPreviewValue",
    field: field,
    fieldsType: fieldsType
  }));

  if (fieldsType === PkpassFieldsType.PrimaryFields) {
    content = /*#__PURE__*/React.createElement(FieldPreviewPrimary, {
      values: field
    });
  }

  return /*#__PURE__*/React.createElement("div", {
    key: field.key,
    draggable: !!onFieldDnD,
    onDragOver: onFieldDnD ? onDragOver : undefined,
    onDrop: onFieldDnD ? onDrop : undefined,
    onDragStart: onFieldDnD ? onDragStart : undefined,
    onDragLeave: onFieldDnD ? onDragLeave : undefined,
    className: `field ${fieldsType} ${classes.field}`,
    style: _objectSpread(_objectSpread({}, style), dragOver ? theme.dragOver : {}),
    onClick: event => {
      if (onFieldClick) {
        onFieldClick({
          fieldsType,
          field,
          fieldIndex
        }, event);
      }
    }
  }, content);
};

Field.propTypes = {
  fieldIndex: _pt.number.isRequired,
  align: _pt.oneOf(['left', 'right'])
};
export default Field;
//# sourceMappingURL=Field.js.map